import { CONTACT_RESULT } from './ProcessForwardingCallHistory'
import { parseDate } from './utils'
import { i18n } from 'localization'

export default class ProcessForwarding {
	static fromJSON(json) {
		return new ProcessForwarding(json.id)
			.withCompletionUser(json.creationUser)
			.withCompletionDate(json.creationDate)
			.withContact(json.contactInfo)
			.withInjuredInfo(json.nif, json.email)
			.withDataValidation(json.dataValidation)
			.withInjury(json.bodyPart, json.injuryType)
			.withMedicalAssistanceInfo(json.medicalAssistanceInfo)
			.withDataDisparity(json.dataValidation)
			.withObservations(json.observations)
			.withNoReasonContact(json.noContactReasonString)
			.withFollowUpNetwork(
				json.followUpTrustNetwork,
				json.outsideNetworkReason,
				json.otherOutsideNetworkReason
			)
			.withContactAttempts(json.contactAttempts)
	}

	constructor(id) {
		this.id = id
		this.textId = `process_forwarding_${id || ''}`
		this.key = this.textId
	}

	withNoReasonContact(noReasonContact) {
		this.noReasonContact = noReasonContact
		return this
	}

	withCompletionUser(completionUser) {
		this.completionUser = completionUser
		return this
	}

	withCompletionDate(completionDateStr) {
		if (completionDateStr) {
			this.completionDate = parseDate(completionDateStr)
		} else {
			this.date = {}
		}
		return this
	}

	withContact(contactInfo) {
		this.contact = contactInfo
		return this
	}

	withInjuredInfo(nif, email) {
		this.injuredInfo = {
			email,
			nif,
		}
		return this
	}

	withDataValidation(dataValidation) {
		this.dataValidation = {
			...dataValidation,
		}
		return this
	}

	withInjury(bodyPart, injuryType) {
		this.injury = {
			bodyPart: bodyPart?.name,
			type: injuryType,
		}
		return this
	}

	withMedicalAssistanceInfo(medicalAssistanceInfo) {
		const {
			dischargeForecastDate,
			hospitalDate,
			medicalDischargeStartDate,
			workDisabilityStartDate,
			workDisabilityEndDate,
		} = medicalAssistanceInfo
		this.medicalAssistanceInfo = {
			...medicalAssistanceInfo,
			dischargeForecastDate: dischargeForecastDate
				? parseDate(dischargeForecastDate)
				: {},
			hospitalDate: hospitalDate ? parseDate(hospitalDate) : {},
			medicalDischargeStartDate: medicalDischargeStartDate
				? parseDate(medicalDischargeStartDate)
				: {},
			workDisabilityStartDate: workDisabilityStartDate
				? parseDate(workDisabilityStartDate)
				: {},
			workDisabilityEndDate: workDisabilityEndDate
				? parseDate(workDisabilityEndDate)
				: {},
		}
		return this
	}

	withDataDisparity(dataValidation) {
		const missingFields = Object.entries(dataValidation)
			.map(([key, { validation }]) => {
				if (!validation) {
					return i18n.translate(key)
				}
				return null
			})
			.filter((f) => f)

		const hasDisparity = !!Object.values(dataValidation || {}).find(
			({ validation }) => !validation
		)

		this.disparity = {
			hasDisparity,
			missingFields,
		}
		return this
	}

	withObservations(observations) {
		this.observation = observations
		return this
	}

	withFollowUpNetwork(
		followUpTrustNetwork,
		outsideNetworkReason,
		otherOutsideNetworkReason
	) {
		this.followUpNetwork = {
			followUpTrustNetwork,
			outsideNetworkReason,
			otherOutsideNetworkReason,
		}
		return this
	}

	withContactAttempts(contactAttempts) {
		this.contactAttempts = (contactAttempts || []).map(
			({ creationDate, contactResult }) => {
				return {
					date: creationDate ? parseDate(creationDate) : {},
					success: contactResult?.id === CONTACT_RESULT.SUCCESS,
				}
			}
		)
		return this
	}
}
